export function vIf(condition: boolean | Array<boolean>, component) {
    if (Array.isArray(condition)) {
        return condition.every((item) => !!item) ? component : null;
    }
    return condition ? component : null;
}

export function vIfElse(condition: boolean | Array<boolean>, ifComponent, elseComponent) {
    if (Array.isArray(condition)) {
        return condition.every((item) => !!item) ? ifComponent : elseComponent;
    }
    return condition ? ifComponent : elseComponent;
}
